import { render, staticRenderFns } from "./IrrigationSystems.vue?vue&type=template&id=12d5b4fc&scoped=true"
import script from "./IrrigationSystems.vue?vue&type=script&lang=js"
export * from "./IrrigationSystems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d5b4fc",
  null
  
)

export default component.exports